function t(t,r){return(t<0?"-":"")+Math.abs(t).toString().padStart(r,"0")}export{t as addLeadingZeros};
//# sourceMappingURL=addLeadingZeros.js.map
